<template>
  <div class="address-item">
    <div class="address-item-cnt">
      <van-cell
        required
        :title="title"
        :value="displayValue"
        is-link
        @click="showPopup"
        :label="isRequired && !selectedValues.length ? '请选择' + title : ''"
      />
      <!-- <span class="custom-hint">这里是提示语</span> -->
      <van-popup
        closeable
        close-icon="http://cdn.static.k618.cn/newmediacenter/resources/snd/202503/4/i20250304_7d9ca35a00cf079c62f79ec1ba967366.png"
        v-model:show="show"
        position="bottom"
        :style="{ height: '30%' }"
        @close="close"
      > 
        <div > 
          <van-cell style="text-align: center;" center title="请选择" > </van-cell>
        </div>
        <div class="select-item-cnt-cell">
          <!-- 添加全选功能 -->
          <van-cell title="全选" @click="toggleSelectAll">
            <template #right-icon>
              <van-icon 
                :name="isAllSelected ? 'success' : ''" 
                color="#07c160"
              />
            </template>
          </van-cell>
          
          <!-- 添加多选状态展示 -->
          <van-cell
            v-for="{ value, key } in list"
            :key="key"
            :title="value"
            @click="toggleSelect(key, value)"
          >
            <template #right-icon>
              <van-icon 
                :name="selectedValues.includes(key) ? 'success' : ''" 
                color="#07c160"
              />
            </template>
          </van-cell>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed, watch } from "vue";

export default {
  name: "MultiSelect",
  props: {
    title: String,
    value: {
      type: Array,
      default: () => []
    },
    list: {
      type: Array,
      default: () => []
    },
    handlerSelect: Function,
    isClick: {
      type: Boolean,
      default: true
    },
    isRequired: Boolean
  },

  setup(props) {
    const state = reactive({
      show: false,
      selectedValues: [],  // 存储选中值的key
      selectedLabels: []  // 存储选中值的显示文本
    });

    watch(
      () => props.value,
      (newVal) => {
        state.selectedValues = [...newVal];
        // 根据 keys 从 list 中匹配 labels
        state.selectedLabels = newVal.map(key => {
          const item = props.list.find(item => item.key === key);
          return item ? item.value : '';
        }).filter(label => label); // 过滤无效值
      },
      { immediate: true } // 立即执行以初始化
    );

    // 计算显示值
    const displayValue = computed(() => {
      return state.selectedLabels.length > 0 
        ? state.selectedLabels.join(", ") 
        : "请选择";
    });

    // 全选状态计算
    const isAllSelected = computed(() => {
      return props.list.every(item => 
        state.selectedValues.includes(item.key)
      );
    });

    // 切换单个选项
    const toggleSelect = (key, value) => {
      const index = state.selectedValues.indexOf(key);
      if (index === -1) {
        state.selectedValues.push(key);
        state.selectedLabels.push(value);
      } else {
        state.selectedValues.splice(index, 1);
        state.selectedLabels.splice(
          state.selectedLabels.findIndex(v => v === value), 1
        );
      }
    };

    // 全选/取消全选
    const toggleSelectAll = () => {
      if (isAllSelected.value) {
        state.selectedValues = [];
        state.selectedLabels = [];
      } else {
        state.selectedValues = props.list.map(item => item.key);
        state.selectedLabels = props.list.map(item => item.value);
      }
    };

    // 关闭弹窗时回调
    const close = () => {
      state.show = false;
      props.handlerSelect?.({
        keys: state.selectedValues,
        labels: state.selectedLabels
      });
    };

    return {
      ...toRefs(state),
      displayValue,
      isAllSelected,
      showPopup: () => state.show = true,
      close,
      toggleSelect,
      toggleSelectAll
    };
  }
};
</script>

<style lang="less" scoped>
:deep(.van-cell__label) {
  color: #ee0a24;
}
.van-cell__right-icon {
  font-size: 16px;
}
.select-item-cnt-cell {
  padding-bottom: 30px;  /* 防止底部被遮挡 */
}
.custom-hint {
  display: block;        /* 确保提示语作为块级元素显示在新的一行 */
  text-align: right;     /* 文本靠右对齐 */
  margin-top: 4px;       /* 根据需要调整与上方 <van-cell> 的间距 */
  margin-right: 20px;
  font-size: 12px;       /* 根据需要调整字体大小 */
  color: #ee0a24;        /* 根据需要调整字体颜色，这里使用了与标签相同的颜色作为示例 */
}
:deep(.van-icon__image) {
  width: 2em;
}
</style>